import {
    listRequest,
    listResponse,
    listCachedResponse,
    listErrorResponse
} from "./default-actions/paging-actions"
import {
    SESSION_LIST_REQUEST,
    SESSION_LIST_RESPONSE,
    SESSION_LIST_CACHED_RESPONSE,
    SESSION_LIST_ERROR_RESPONSE
} from "./action-types"

// Session Paging Actions
export const sessionListRequest = listRequest(SESSION_LIST_REQUEST)
export const sessionListResponse = listResponse(SESSION_LIST_RESPONSE)
export const sessionListCachedResponse = listCachedResponse(
    SESSION_LIST_CACHED_RESPONSE
)
export const sessionListErrorResponse = listErrorResponse(
    SESSION_LIST_ERROR_RESPONSE
)
